var FinanceElementsTypes;
(function (FinanceElementsTypes) {
    FinanceElementsTypes["INTEREST_RATE"] = "interestRate";
    FinanceElementsTypes["COMPARISON_RATE"] = "comparisonRate";
    FinanceElementsTypes["CHOSEN_TERM"] = "chosenTerm";
    FinanceElementsTypes["CHOSEN_RATE"] = "chosenRate";
    FinanceElementsTypes["TERM"] = "term";
    FinanceElementsTypes["TERM_IN_YEARS"] = "termInYears";
    FinanceElementsTypes["DEPOSIT_PERCENTAGE"] = "depositPercentage";
    FinanceElementsTypes["MONTHLY_INTEREST"] = "monthlyInterest";
    FinanceElementsTypes["FINANCE_DEPOSIT"] = "financeDeposit";
})(FinanceElementsTypes || (FinanceElementsTypes = {}));
export default FinanceElementsTypes;
//# sourceMappingURL=FinanceElementsTypes.js.map